import { useEffect, useState } from "react";
import { TextField, Button, Box, Stack, Grid } from "@mui/material";
import AppBarExplorer from "../../components/AppBar/Explorer";
import FloweringTime from "../../components/Explorer/Plant/FloweringTime";
import Native from "../../components/Explorer/Plant/Native";
import Category from "../../components/Explorer/Plant/Category";
import Sunlight from "../../components/Explorer/Plant/Sunlight";
import { Typography } from "@mui/material";
import { Divider } from "@mui/material";
import { uploadDataWithName } from "../../libs/firebase/firestore/uploadDataWithName";
import { getData } from "../../libs/firebase/firestore/getData";
import { updateData } from "../../libs/firebase/firestore/updateData";
import PlantCard from "../../components/Explorer/Plant/Card";
import { getAllData } from "../../libs/firebase/firestore/getAllData";
import FilterModal from "../../components/Explorer/Plant/Filters";
// import { db } from "../../firebase";

function filterPlants(filters, plants) {
  let filteredPlants = plants;
  // for each plant
  filteredPlants = filteredPlants.filter((plant) => {
    // check category array
    if (
      filters.category &&
      filters.category.length > 0 &&
      !filters.category.some((item) =>
        plant.category

          .map((cat) => cat.toLowerCase())
          .includes(item.toLowerCase())
      )
    ) {
      return false;
    }
    // check flowering time array contains one of the flowering times in the filter array
    if (
      filters.floweringTime &&
      filters.floweringTime.length > 0 &&
      !filters.floweringTime.some((item) =>
        plant.floweringTime
          .map((time) => time.toLowerCase())
          .includes(item.toLowerCase())
      )
    ) {
      return false;
    }
    // check sunlight array
    if (
      filters.sunlight &&
      filters.sunlight.length > 0 &&
      !filters.sunlight.some((item) =>
        plant.sunlight
          .map((sun) => sun.toLowerCase())
          .includes(item.toLowerCase())
      )
    ) {
      return false;
    }
    // check soil array
    if (
      filters.soil &&
      filters.soil.length > 0 &&
      !filters.soil.some((item) =>
        plant.soil
          .map((soil) => soil.toLowerCase())
          .includes(item.toLowerCase())
      )
    ) {
      return false;
    }
    // check water array
    if (
      filters.water &&
      filters.water.length > 0 &&
      !filters.water.some((item) =>
        plant.water
          .map((water) => water.toLowerCase())
          .includes(item.toLowerCase())
      )
    ) {
      return false;
    }
    // check width
    if (
      filters.width &&
      filters.width.length > 0 &&
      (plant.width < filters.width[0] || plant.width > filters.width[1])
    ) {
      return false;
    }
    // check height
    if (
      filters.height &&
      filters.height.length > 0 &&
      (plant.height < filters.height[0] || plant.height > filters.height[1])
    ) {
      return false;
    }
    return true;
  });
  return filteredPlants;
}

export default function ExplorerRoot() {
  // state for plants
  const [plants, setPlants] = useState([]);

  // state for filters
  const [filters, setFilters] = useState({});

  useEffect(() => {
    // get the plants from firebase
    getAllData(
      "plants",
      (data) => {
        // remove data where storageDocumentId is all
        data = data.filter((item) => item.storageDocumentId !== "all");
        setPlants(data);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  // apply filters to plants
  const plantsToShow = filterPlants(filters, plants);

  return (
    <Box>
      <AppBarExplorer />
      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Explorer</Typography>
        <Typography variant="subtitle1">Find plants</Typography>
        <FilterModal
          filters={filters}
          onSubmit={(data) => {
            // set filters
            setFilters(data);
          }}
        />
        <Divider
          sx={{
            my: 2,
          }}
        />
        <Grid container spacing={2}>
          {plantsToShow.map((plant, index) => {
            return (
              <Grid item xs={6} key={index}>
                <PlantCard plant={plant} />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
}
